import { useWebsiteInfo } from '../useWebsiteInfo';
import { PagesTable } from './pagesTable';
const getTableData = (pages) => {
  return Object.keys(pages).map((pageKey) => {
    const pageData = pages[pageKey];
    return {
      pageKey: pages[pageKey].template ? `pages/${pageKey}` : pageKey,
      title: pageData?.title,
    };
  });
};

export default function PagesList() {
  const { pages, dynamicPages } = useWebsiteInfo();
  return <PagesTable pages={getTableData({ ...pages, ...dynamicPages })} />;
}

PagesList.url = '';
